import { defineStore } from 'pinia'
import { store } from '@/store'
import type { ResGetSystemConfig } from '@/api/type/result'
import { commonApi } from '@/api/commonApi'
import { Code } from '@/config/httpCode'
export const useSystemConfigStore = defineStore({
  id: 'storeSystemConfig',
  state: () => ({
    systemConfig: {
      verifyCodeMaxRetry: null,
      enableTrainedVoiceClone: null,
      frontEndVersion: null,
      urlFaq: null,
      urlUserGuide: null,
      rebateConfig: {
        rebateDescription: '',
        inviteMessage: '',
        withDrawEnabled: false,
        withDrawMinAmount: 0,
        withDrawMaxAmount: 0,
      },
      mvBannerVideo: null,
      mvBanner: [],
    } as ResGetSystemConfig,
  }),
  actions: {
    async getSystemConfig() {
      const res = await commonApi.getSystemConfig()
      if (res.statusCode === Code.SUCCESS.statusCode) {
        this.systemConfig = res.data
      }
    },
  },
})
export function useSystemConfigStoreHook() {
  return useSystemConfigStore(store)
}
